import { render, staticRenderFns } from "./CenterArea.vue?vue&type=template&id=5fe9fe74&"
import script from "./CenterArea.vue?vue&type=script&lang=js&"
export * from "./CenterArea.vue?vue&type=script&lang=js&"
import style0 from "./CenterArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports